<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="intEdit" v-if="isMounted">
        <ValidationObserver ref="form" class="centerx default-input">
            <vs-row class="mb-4">
                <vs-col vs-w="4">
                    <div class="pl-2 pr-2">
                        <ValidationProvider vid="name" :name="$t('global.Name')" rules="required|minmax:3,50" v-slot="{ errors }">
                            <label class="text-sm opacity-75">{{$t('global.Name')}}</label>
                            <vs-input
                                class="inputx w-full"
                                :placeholder="$t('global.Name')"
                                v-model="name"
                            />
                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </vs-col>
                <vs-col vs-w="8">
                    <div class="pl-2 pr-2">
                        <label class="text-sm opacity-75">{{$t('global.Description')}}</label>
                        <vs-input
                            class="inputx w-full"
                            :placeholder="$t('global.Description')"
                            v-model="description"
                        />
                    </div>
                </vs-col>
            </vs-row>

            <vs-row class="mb-4" v-if="is_falcon">
                <vs-col vs-w="12">
                    <div class="pl-2 pr-2">
                        <ValidationProvider vid="url" :name="$t('modals.URL')" rules="required|url" v-slot="{ errors }">
                            <label class="text-sm opacity-75">{{$t('modals.URL')}}</label>
                            <vs-input
                                name="url"
                                class="inputx w-full"
                                :placeholder="$t('modals.URL')"
                                v-model="url"
                            />
                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </vs-col>
            </vs-row>

            <vs-row class="mb-4" v-if="is_falcon">
                <vs-col vs-w="6">
                    <div class="pl-2 pr-2">
                        <ValidationProvider vid="login" :name="$t('modals.Login')" rules="required" v-slot="{ errors }">
                            <label class="text-sm opacity-75">{{$t('modals.Login')}}</label>
                            <vs-input
                                class="inputx w-full"
                                :placeholder="$t('modals.Login')"
                                v-model="login"
                            />
                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </vs-col>
                <vs-col vs-w="6">
                    <div class="pl-2 pr-2">
                        <ValidationProvider vid="password" :name="$t('modals.Password')" rules="required" v-slot="{ errors }">
                            <label class="text-sm opacity-75">{{$t('modals.Password')}}</label>
                            <vs-input
                                class="inputx w-full"
                                :placeholder="$t('modals.Password')"
                                type="password"
                                v-model="password"
                            />
                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </vs-col>
            </vs-row>
            <div v-if="!is_falcon">
                <div class="pl-2 pr-2" style="font-size: 18px;">{{$t('global.Integration_Parameters')}}</div>
                <vs-col v-for="(value, key) in params" :key="key">
                    <vs-row v-if="!Array.isArray(value)">
                        <vs-col vs-w="12">
                            <div class="pl-2 pr-2 pt-2 pb-2">
                                <ValidationProvider :vid="key" :name="key.toUpperCase()" :rules="{required: true, url:key === 'url' }" v-slot="{ errors }">
                                    <label class="text-sm opacity-75">{{ key.toUpperCase() }}</label>
                                    <vs-input
                                        class="inputx w-full"
                                        :placeholder="key.toUpperCase()"
                                        v-model="params[key]"
                                    />
                                    <span class="text-danger text-xs" >{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </vs-col>
                    </vs-row>

                    <div v-else-if="Array.isArray(value) && value.length && key !== 'params'" class="pl-2 pr-2 pt-2 pb-2">
                        <div class="pl-2 pr-2 mb-4" style="font-size: 18px;">{{key.toUpperCase()}}</div>
                        <vs-card v-for="(element, index) of value" :key="index">
                            <vs-row class="items-center">
                                <vs-col vs-w="6" v-for="(nameProperty, i) of Object.keys(element)" :key="i">
                                    <div class="pl-2 pr-2 pt-2 pb-2">
                                        <ValidationProvider :vid="nameProperty + '_' + index" :name="nameProperty.toUpperCase()" :rules="{ required: true, max: 100, url:nameProperty === 'url' }" v-slot="{ errors }">
                                            <label class="text-sm opacity-75">{{ nameProperty.toUpperCase() }}</label>
                                            <vs-input
                                                :disabled="nameProperty === 'offer' || nameProperty === 'country'"
                                                class="inputx w-full"
                                                :placeholder="nameProperty.toUpperCase()"
                                                v-model="element[nameProperty]"
                                            />
                                            <span class="text-danger text-xs ">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </vs-col>
                            </vs-row>
                        </vs-card>
                    </div>
                    <!--                    If integration_params have property params-->
                    <div v-else-if="Array.isArray(value) && key === 'params'" class="pl-2 pr-2 pt-2 pb-2">
                        <div class="pl-2 pr-2 mb-4" style="font-size: 18px;">{{key.toUpperCase()}}</div>
                        <vs-card v-for="(element, index) of value" :key="index">
                            <vs-row class="items-center">
                                <vs-col vs-w="9">
                                    <div v-for="(nameProperty, i) of Object.keys(element)" :key="i">
                                        <div class="pl-2 pr-2 pt-2 pb-2">
                                            <ValidationProvider :vid="nameProperty + '_' + index" :name="nameProperty.toUpperCase()" :rules="{ max: 100, url:nameProperty === 'url' }" v-slot="{ errors }">
                                                <label class="text-sm opacity-75">{{ nameProperty.toUpperCase() }}</label>
                                                <vs-input
                                                    :disabled="nameProperty === 'offer' || nameProperty === 'country'"
                                                    class="inputx w-full"
                                                    :placeholder="nameProperty.toUpperCase()"
                                                    v-model="element[nameProperty]"
                                                />
                                                <span class="text-danger text-xs ">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </vs-col>
                                <vs-col v-if="index === value.length - 1" :vs-w="3" class="flex ">
                                    <vs-button
                                        v-if="index !== 0"
                                        @click.prevent="removeParam(index,key)"
                                        radius
                                        class="ml-5"
                                        color="primary"
                                        type="filled"
                                        v-tooltip="$t('tooltip.delete_param')"
                                        v-bind="$iconData('icon-minus', 'fi-rr-minus-small')"
                                    />
                                    <vs-button
                                        @click.prevent="addNewParam(element, key)"
                                        radius
                                        class="ml-5"
                                        color="primary"
                                        type="filled"
                                        v-tooltip="$t('tooltip.add_param')"
                                        v-bind="$iconData('icon-plus', 'fi-rr-plus')"
                                    />
                                </vs-col>
                                <vs-col v-else vs-w="3" class="flex">
                                    <vs-button
                                        @click.prevent="removeParam(index,key)"
                                        radius
                                        class="ml-5"
                                        color="primary"
                                        type="filled"
                                        v-bind="$iconData('icon-minus', 'fi-rr-minus-small')"
                                        v-tooltip="$t('tooltip.delete_param')"
                                    />
                                </vs-col>
                            </vs-row>
                        </vs-card>
                    </div>
                </vs-col>
            </div>

            <div>
                <vs-row v-if="Array.isArray(integrationParameters)">
                    <vs-col vs-w="12">
                        <div class="p-2 pb-4 flex justify-center">
                            <vs-button
                                color="primary"
                                type="filled"
                                @click="() => showParams = !showParams"
                            >{{ $t('global.submitted_fields') }}
                            </vs-button>
                        </div>
                    </vs-col>
                </vs-row>

                <vs-row v-show="showParams && Array.isArray(integrationParameters)">
                    <vs-col vs-w="12" v-for="(param, index) of integrationParameters" :key="index">
                        <div class="flex items-center w-full card">
                            <vs-row>
                                <vs-col vs-w="12">
                                    <vs-row>
                                        <vs-col vs-w="12" vs-type="flex" vs-align="center" vs-justify="space-between">
                                            <div class="flex items-center">
                                                <vs-checkbox
                                                    :disabled="param.multiple || param.condition"
                                                    @change="changeCustom(param)"
                                                    v-model="param.custom"
                                                >{{ $t('global.Custom') }}
                                                </vs-checkbox>

                                                <vs-checkbox
                                                    @change="() => {
                                                        param.get = ''
                                                        param.separator = null
                                                    }"
                                                    :disabled="param.custom || param.condition"
                                                    class="ml-3"
                                                    v-model="param.multiple"
                                                >{{ $t('global.Multiple') }}</vs-checkbox>

                                                <vs-checkbox
                                                    @change="setParam(param)"
                                                    :disabled="param.custom || param.multiple"
                                                    class="ml-3"
                                                    v-model="param.condition"
                                                >{{ $t('global.Conditions') }}</vs-checkbox>
                                            </div>

                                            <div class="flex items-center">
                                                <div
                                                    class="cursor-pointer p-1"
                                                    v-if="integrationParameters.length > 1"
                                                    v-tooltip="$t('buttons.Delete')"
                                                    @click="parameterAction(index)"
                                                >
                                                    <vs-icon v-bind="$iconData('icon-minus', 'fi-rr-minus-small')"
                                                             size="small"
                                                    ></vs-icon>
                                                </div>

                                                <div
                                                    class="cursor-pointer p-1"
                                                    v-if="index === (integrationParameters.length - 1)"
                                                    v-tooltip="$t('buttons.Add')"
                                                    @click="parameterAction()"
                                                >
                                                    <vs-icon v-bind="$iconData('icon-plus', 'fi-rr-plus')"
                                                             size="small"
                                                    ></vs-icon>
                                                </div>
                                            </div>
                                        </vs-col>

                                        <template v-if="!param.condition">
                                            <vs-col :vs-w="4">
                                                <ValidationProvider
                                                    :vid="'parameter_name_' + index"
                                                    :name="$t('label.Parameter_name')"
                                                    rules="max:250"
                                                    v-slot="{ errors }"
                                                >
                                                    <div class="relative" :class="{error: !!errors[0]}">
                                                        <label
                                                            class="text-sm opacity-75 mr-4">{{
                                                                $t('label.Parameter_name')
                                                            }}</label>
                                                        <vs-input
                                                            class="w-full"
                                                            name="parameter_name"
                                                            :placeholder="$t('label.Parameter_name')"
                                                            v-model.trim="param.send"
                                                        />
                                                        <vs-icon
                                                            v-if="errors[0]"
                                                            v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')"
                                                            color="danger"
                                                            size="small"
                                                            style="position: absolute; right: -10px; top: 10px"
                                                            v-tooltip="errors[0]"
                                                        ></vs-icon>
                                                    </div>
                                                </ValidationProvider>
                                            </vs-col>

                                            <vs-col :vs-w="4">
                                                <ValidationProvider
                                                    :vid="param.multiple ? 'separator_' + index : 'value_' + index"
                                                    :name="param.multiple ? $t('global.Separator') : $t('global.Value')"
                                                    rules="max:250"
                                                    v-slot="{ errors }"
                                                >
                                                    <div class="relative pl-4" :class="{error: !!errors[0]}">
                                                        <label
                                                            class="text-sm opacity-75 mr-4">{{
                                                                param.multiple ? $t('global.Separator') : $t('global.Value')
                                                            }}</label>
                                                        <vs-input
                                                            v-if="param.custom && !param.type"
                                                            v-model.trim="param.get"
                                                            class="w-full"
                                                            name="value"
                                                            :placeholder="$t('global.Value')"
                                                        />

                                                        <vs-input
                                                            v-if="param.custom && param.type === 'integer'"
                                                            v-model.trim="param.get"
                                                            class="w-full"
                                                            name="value"
                                                            :placeholder="$t('global.Value')"
                                                            @keypress="onKeypressInteger"
                                                            @paste="onPasteInteger"
                                                            @drop.prevent
                                                        />

                                                        <v-select
                                                            v-if="!param.multiple && !param.custom"
                                                            v-model="param.get"
                                                            class="w-full"
                                                            name="value"
                                                            :placeholder="$t('global.Value')"
                                                            :options="available_fields"
                                                            :multiple="param.multiple"
                                                        />

                                                        <v-select
                                                            v-if="param.multiple"
                                                            v-model="param.separator"
                                                            class="w-full"
                                                            name="value"
                                                            :placeholder="$t('global.Separator')"
                                                            :options="separators"
                                                        />

                                                        <v-select
                                                            v-if="param.type === 'boolean'"
                                                            v-model="param.get"
                                                            class="w-full"
                                                            name="value"
                                                            :placeholder="$t('global.Value')"
                                                            :options="getOptions"
                                                        />

                                                        <vs-icon
                                                            v-if="errors[0]"
                                                            v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')"
                                                            color="danger"
                                                            size="small"
                                                            style="position: absolute; right: -10px; top: 10px"
                                                            v-tooltip="errors[0]"
                                                        ></vs-icon>
                                                    </div>
                                                </ValidationProvider>
                                            </vs-col>

                                            <vs-col
                                                v-if="!param.custom"
                                                :vs-w="4"
                                            >
                                                <div class="relative pl-4">
                                                    <label class="text-sm opacity-75 mr-4">{{ $t('global.Action') }}</label>
                                                    <v-select
                                                        v-model="param.action"
                                                        class="w-full"
                                                        name="action"
                                                        label="name"
                                                        :reduce="a => a.value"
                                                        :placeholder="$t('global.Action')"
                                                        :options="actions"
                                                    />
                                                </div>
                                            </vs-col>

                                            <vs-col :vs-w="4" v-if="param.custom">
                                                <div class="pl-4">
                                                    <label class="text-sm opacity-75 mr-4">{{ $t('global.Type') }}</label>
                                                    <v-select
                                                        v-model="param.type"
                                                        class="w-full"
                                                        name="type"
                                                        label="name"
                                                        :reduce="a => a.value"
                                                        :placeholder="$t('global.Type')"
                                                        :options="types"
                                                        @input="changeType(param)"
                                                    />
                                                </div>
                                            </vs-col>

                                            <vs-col vs-w="12" v-if="param.multiple">
                                                <ValidationProvider
                                                    :vid="'value_' + index"
                                                    :name="$t('global.Value')"
                                                    rules="required|max:250"
                                                    v-slot="{ errors }"
                                                >
                                                    <div class="mt-3 relative" :class="{error: !!errors[0]}">
                                                        <label
                                                            class="text-sm opacity-75 mr-4">{{ $t('global.Value') }}</label>
                                                        <v-select
                                                            v-model="param.get"
                                                            class="w-full"
                                                            name="value"
                                                            :placeholder="$t('global.Value')"
                                                            :options="available_fields"
                                                            :multiple="param.multiple"
                                                            :closeOnSelect="false"
                                                        />
                                                        <vs-icon
                                                            v-if="errors[0]"
                                                            v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')"
                                                            color="danger"
                                                            size="small"
                                                            style="position: absolute; right: -10px; top: 10px"
                                                            v-tooltip="errors[0]"
                                                        ></vs-icon>
                                                    </div>
                                                </ValidationProvider>
                                            </vs-col>
                                        </template>

                                        <template v-else>
                                            <vs-col :vs-w="6">
                                                <div class="pb-2 pt-2">
                                                    IF
                                                </div>
                                            </vs-col>

                                            <vs-col :vs-w="6">
                                                <div class="pl-4 pb-2 pt-2">
                                                    SEND KEY
                                                </div>
                                            </vs-col>

                                            <vs-col :vs-w="6">
                                                <div class="pb-2 pt-2">
                                                    <ValidationProvider
                                                        :vid="'parameter_name_' + index"
                                                        :name="$t('label.changeParameter')"
                                                        rules="required|max:250"
                                                        v-slot="{ errors }"
                                                    >
                                                        <v-select
                                                            v-model="param.get"
                                                            :options="available_fields"
                                                            :clearable="false"
                                                            :placeholder="$t('label.changeParameter')"
                                                        />
                                                        <span class="text-danger text-xs" >{{ errors[0] }}</span>
                                                    </ValidationProvider>
                                                </div>
                                            </vs-col>

                                            <vs-col :vs-w="6">
                                                <div class="pl-4 pb-2 pt-2">
                                                    <ValidationProvider
                                                        :vid="'send_' + index"
                                                        :name="$t('label.enterKey')"
                                                        rules="required|max:250"
                                                        v-slot="{ errors }"
                                                    >
                                                        <vs-input
                                                            class="w-full"
                                                            :placeholder="$t('label.enterKey')"
                                                            v-model="param.send"
                                                        />
                                                        <span class="text-danger text-xs" >{{ errors[0] }}</span>
                                                    </ValidationProvider>
                                                </div>
                                            </vs-col>

                                            <vs-row v-for="(item, ind) in param.conditions"
                                                    :key="ind"
                                            >
                                                <vs-col :vs-w="6">
                                                    <div class="pb-2 pt-2">
                                                        <div v-if="ind === 0">=</div>
                                                        <div v-else>ELSE IF =</div>
                                                    </div>
                                                </vs-col>

                                                <vs-col :vs-w="5">
                                                    <div class="pl-4 pb-2 pt-2">
                                                        SEND VALUE
                                                    </div>
                                                </vs-col>

                                                <vs-col :vs-w="1" vs-type="flex" vs-align="center" vs-justify="end">
                                                    <div
                                                        class="cursor-pointer pl-1"
                                                        v-if="param.conditions.length > 1"
                                                        v-tooltip="$t('buttons.Delete')"
                                                        @click="conditionAction(param.conditions, ind)"
                                                    >
                                                        <vs-icon
                                                            v-bind="$iconData('icon-minus', 'fi-rr-minus-small')"
                                                            size="small"
                                                        ></vs-icon>
                                                    </div>

                                                    <div
                                                        class="cursor-pointer p-1"
                                                        v-if="ind === param.conditions.length - 1"
                                                        v-tooltip="$t('buttons.Add')"
                                                        @click="conditionAction(param.conditions)"
                                                    >
                                                        <vs-icon
                                                            v-bind="$iconData('icon-plus', 'fi-rr-plus')"
                                                            size="small"
                                                        ></vs-icon>
                                                    </div>
                                                </vs-col>

                                                <vs-col :vs-w="6">
                                                    <div class="pb-2 pt-2">
                                                        <ValidationProvider
                                                            :vid="'item_key_' + index + '_' + ind"
                                                            :name="$t('label.enterKey')"
                                                            :rules="{
                                                                required: true,
                                                                max: 250,
                                                                uniqueInArray: { items: param.conditions, field: 'key' }
                                                            }"
                                                            v-slot="{ errors }"
                                                        >
                                                            <vs-input
                                                                class="w-full"
                                                                :placeholder="$t('label.enterKey')"
                                                                v-model="item.key"
                                                            />
                                                            <span class="text-danger text-xs">{{ errors[0] }}</span>
                                                        </ValidationProvider>
                                                    </div>
                                                </vs-col>

                                                <vs-col :vs-w="6">
                                                    <div class="pl-4 pb-2 pt-2">
                                                        <ValidationProvider
                                                            :vid="'item_value' + index"
                                                            :name="$t('label.enterValue')"
                                                            rules="required|max:250"
                                                            v-slot="{ errors }"
                                                        >
                                                            <vs-input
                                                                class="w-full"
                                                                :placeholder="$t('label.enterValue')"
                                                                v-model="item.value"
                                                            />
                                                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                                                        </ValidationProvider>
                                                    </div>
                                                </vs-col>
                                            </vs-row>

                                            <vs-col :vs-w="6"></vs-col>

                                            <vs-col :vs-w="6">
                                                <div class="pl-4 pb-2 pt-2">
                                                    DEFAULT VALUE
                                                </div>
                                            </vs-col>

                                            <vs-col :vs-w="6"></vs-col>

                                            <vs-col :vs-w="6">
                                                <div class="pl-4 pb-2 pt-2">
                                                    <vs-input
                                                        class="w-full"
                                                        placeholder="Enter value"
                                                        v-model="param.default_condition_option"
                                                    />
                                                </div>
                                            </vs-col>
                                        </template>
                                    </vs-row>
                                </vs-col>
                            </vs-row>
                        </div>
                    </vs-col>
                </vs-row>
            </div>

            <div>
                <vs-row class="mb-4">
                    <vs-col vs-w="6">
                        <div class="pl-2 pr-2 flex items-center">
                            <label class="text-sm opacity-75 mr-4">{{$t('label.Sync_available')}}</label>
                            <vs-switch color="success" icon-pack="feather" v-model="is_sync_available" vs-icon-off="icon-x"
                                       vs-icon-on="icon-check"/>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="pl-2 pr-2 flex items-center">
                            <label class="text-sm opacity-75 mr-4">{{$t('label.Only_hot_trafic')}}</label>
                            <vs-switch color="success" icon-pack="feather" vs-icon-off="icon-x" v-model="is_hot"
                                       vs-icon-on="icon-check"/>
                        </div>
                    </vs-col>
                </vs-row>
            </div>

            <vs-row class="mb-4">
                <vs-col vs-w="6">
                    <div class="pl-2 pr-2">
                        <ValidationProvider vid="traffic_model_id" :name="$t('global.Model')" rules="required" v-slot="{ errors }">
                            <label class="text-sm opacity-75 mr-4">{{$t('global.Model')}}</label>
                            <v-select
                                :options="options.traffic_models"
                                v-model="traffic_model_id"
                                :clearable="false"
                                :reduce="model => model.id" label="name"
                            />
                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </vs-col>
                <vs-col vs-w="6">
                    <div class="pl-2 pr-2">
                        <ValidationProvider vid="geo_id" :name="$t('global.Geo')" rules="required" v-slot="{ errors }">
                            <label class="text-sm opacity-75 mr-4">{{$t('global.Geo')}}</label>
                            <v-select
                                :options="options.geos"
                                v-model="geo_id"
                                @input="setCountries(true)"
                                :clearable="false"
                                :reduce="geo => geo.id"
                                label="name"
                            />
                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </vs-col>
            </vs-row>

            <vs-row class="mb-4">
                <vs-col vs-w="12">
                    <div class="pl-2 pr-2">
                        <ValidationProvider vid="countries" :name="$t('global.Countries')" rules="required" v-slot="{ errors }">
                            <label class="text-sm opacity-75 mr-4">{{$t('global.Countries')}}</label>
                            <v-select
                                :disabled="!geo_id"
                                multiple
                                :options="options.countries"
                                :clearable="false"
                                label="name"
                                v-model="countries"
                                :closeOnSelect="false"
                            />
                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </vs-col>
            </vs-row>

            <vs-row class="mb-4">
                <vs-col vs-w="12">
                    <div class="pl-2 pr-2">
                        <ValidationProvider vid="offers_accepted" :name="$t('modals.Choose_accepted_offers')" rules="required" v-slot="{ errors }">
                            <label class="text-sm opacity-75 mr-4">{{$t('modals.Choose_accepted_offers')}}</label>
                            <v-select
                                v-model="offers_accepted"
                                :options="options.offers"
                                multiple :clearable="true"
                                :reduce="offer => offer.name" label="name"
                                :closeOnSelect="false"
                            />
                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </vs-col>
            </vs-row>

            <vs-row class="mb-4">
                <vs-col vs-w="12">
                    <div class="pl-2 pr-2">
                        <label class="text-sm opacity-75 mr-4">{{$t('modals.Choose_not_accepted_offers')}}</label>
                        <v-select name="model" v-model="offers_not_accepted" :options="options.accepted_offers" multiple :closeOnSelect="false" :clearable="true"
                                  :reduce="offer => offer.name" label="name"/>
                    </div>
                </vs-col>
            </vs-row>

            <div class="text-right pt-4">
                <vs-button @click="send" :disabled="disabled">
                    {{$t('buttons.Save')}}
                </vs-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import EventBus from '@/store/eventBus'
import send from '@/utils/fetch'
import ErrorHandler from '../../../utils/errorHandler'

export default {
    props: ['popupData', 'popupType', 'popupButton'],

    data() {
        return {
            disabled: false,
            isMounted: false,
            showParams: false,

            name: '',
            description: '',
            url: '',
            login: '',
            password: '',
            token: '',
            is_hot: false,
            is_sync_available: false,

            traffic_model_id: '',
            geo_id: '',
            countries: [],
            params: {},

            integrationParameters: [],

            //////
            offerList: [],
            fieldsList: {},
            //////

            offers_accepted: [],
            offers_not_accepted: [],

            is_falcon: 0,
            integration_type_id: 0,
            options: [],
            typeIntegrations: [],
            integration_params: null,
            templateParams: {
                get: '',
                custom: false,
                send: '',
                type: null
            },
            available_fields: [],
            separators: [';', '/', ',', '*', ':', '-', '#'],
            types: [
                {name: 'Boolean', value: 'boolean'},
                {name: 'Integer', value: 'integer'},
            ],
            getOptions: ['true', 'false']
        }
    },

    components: {
        ValidationProvider,
        ValidationObserver,
        vSelect
    },

    computed: {
        actions() {
          return [
            {
              name: 'To lower',
              value: 'to_lower'
            },
            {
              name: 'To upper',
              value: 'to_upper'
            },
            {
              name: 'Add plus',
              value: 'add_plus'
            }
          ]
        },

        offers () {
            return this.offerList
        }
    },

    watch: {
        offers_accepted(newValue, oldValue) {
            const removed = this._divergencesInArrays(newValue, oldValue)
            const added = this._divergencesInArrays(oldValue, newValue)

            this.changeOfferInCustomIntegration(added, removed)
            this.selectedOfferRemoveOrAdd(added, removed)
        },
        countries(newValue, oldValue){
            const removed = this._divergencesInArrays(newValue, oldValue)
            const added = this._divergencesInArrays(oldValue, newValue)

            this.changeCountryInCustomIntegration(added, removed)
        }
    },

    methods: {
        setParam(param) {
            this.$set(param, 'get', '')
            this.$set(param, 'send', '')
            this.$set(param, 'separator', null)
            this.$set(param, 'conditions', [{ key: '', value: '' }])
            this.$set(param, 'default_condition_option', null)
        },

        changeCustom(param) {
            param.get = ''
            param.type = null
        },

        changeType(param) {
            param.get = ''
        },

        onKeypressInteger(e) {
            const code = e.which || e.keyCode
            if (e.ctrlKey || e.metaKey) {
                return
            }

            if (
                code === 8 ||
                code === 9 ||
                code === 13 ||
                code === 27 ||
                code === 35 ||
                code === 36 ||
                (code >= 37 && code <= 40) ||
                code === 46
            ) {
                return
            }

            if (code < 48 || code > 57) {
                e.preventDefault()
            }
        },

        onPasteInteger(e) {
            const clip = (e.clipboardData || window.clipboardData)
            const text = clip ? (clip.getData && clip.getData('text')) : ''

            if (!/^\d+$/.test((text || '').trim())) {
                e.preventDefault()
            }
        },

        parameterAction(index) {
            if (index !== undefined) {
                this.integrationParameters = this.integrationParameters
                    .filter((item, ind) => ind !== index)
            } else {
                this.integrationParameters.push({
                    get: '',
                    custom: false,
                    send: '',
                    type: null
                })
            }
        },

        conditionAction(conditions, index) {
            if (!Array.isArray(conditions)) {
                return
            }

            if (index !== undefined) {
                conditions.splice(index, 1)
            } else {
                conditions.push({
                    key: '',
                    value: ''
                })
            }
        },

        addNewParam(param, name){
            const newParam = {...param}
            Object.keys(newParam).forEach(key => newParam[key] = '')
            this.params[name].push(newParam)
        },
        removeParam(index, name){
            this.params[name].splice(index, 1)
        },

        _divergencesInArrays(a, b) {
            let str
            b.forEach(element => {
                if (!~a.indexOf(element)) str = element
            })
            return str
        },

        selectedOfferRemoveOrAdd(added, removed) {
            if (added) {
                this.options.accepted_offers = this.options.accepted_offers.filter(offer => offer.name !== added)
                this.offers_not_accepted = this.offers_not_accepted.filter(element => element !== added)
            }

            if (removed) {
                this.options.accepted_offers = this.options.offers
                this.options.accepted_offers = this.options.accepted_offers.filter(element => !this.offers_accepted.includes(element.name))
            }
        },

        async getTypes () {
            try {
                if (this.integration_type_id) {
                    this.typeIntegrations = await send(`${this.$url.advrtsr_integration.getIntegrationType}`, 'GET', {
                        params: {id: this.integration_type_id}
                    }).then(response => response.data.result)

                    const fields = this.typeIntegrations.integration_fields.map(item => {
                      if (item.multiple) {
                        item.get = item.get.split(item.separator)
                      }

                      return item
                    })

                    if (Array.isArray(fields) && !fields.length) {
                        this.integrationParameters.push({...this.templateParams})
                    } else if (Array.isArray(fields) && fields.length) {
                        this.integrationParameters = fields
                    } else {
                        this.integrationParameters = this.typeIntegrations.integration_fields
                    }
                } else {
                    this.typeIntegrations = []
                    this.integrationParameters = [{
                        get: '',
                        custom: false,
                        send: '',
                        type: null
                    }]
                }
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async getDataTeamIntegrations () {
            try {
                this.options = await send(this.$url.advrtsr_integration.getDataTeamIntegrations, 'GET')
                    .then(response => response.data.result)
                this.options.accepted_offers = this.options.offers
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        createInterfaceFields () {
            try {
                let integration_params
                if (this.popupData.custom_integration_params) {
                    integration_params = JSON.parse(this.popupData.custom_integration_params)
                } else {
                    integration_params = this.typeIntegrations ? this.typeIntegrations.integration_params : null
                }

                if (integration_params) {
                    for (const key in integration_params) {
                        if(key === 'params' && Array.isArray(integration_params[key])){
                            this.$set(this.params, key, integration_params[key])
                        } else if (!Array.isArray(integration_params[key])) {
                            this.$set(this.params, key, integration_params[key])
                        }
                    }

                    // code for set property "params" set to the end of the object
                    if (this.params.params) {
                        const temporaryStorage = this.params.params
                        delete this.params.params
                        this.$set(this.params, 'params',  temporaryStorage)
                    }
                }
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        changeOfferInCustomIntegration(addedElement, removedElement) {
            try {
                if (this.typeIntegrations.integration_params && this.typeIntegrations.integration_params.offers){
                    if (removedElement) {
                        this.params.offers = this.params.offers.filter(element => element.offer !== removedElement)
                    } else {
                        if (!this.params.offers) this.params.offers = []
                        if (this.params.offers.length !== this.offers_accepted.length) {
                            this.params.offers.push({
                                ...this.typeIntegrations.integration_params.offers[0],
                                offer: addedElement
                            })
                        }
                    }
                }
            } catch (e) {
                new ErrorHandler(e).send
            }
        },
        changeCountryInCustomIntegration(addedElement, removedElement) {
            try {
                if (this.typeIntegrations.integration_params && this.typeIntegrations.integration_params.countries) {
                    if(removedElement) {
                        this.params.countries = this.params.countries.filter(element => element.country !== removedElement)
                    } else {
                        if(!this.params.countries) this.params.countries = []
                        if(this.params.countries.length !== this.countries.length) {
                            this.params.countries.push({
                                ...this.typeIntegrations.integration_params.countries[0],
                                country: addedElement
                            })
                        }
                    }
                }
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        setCountries (clearSelectedCountries) {
            try {
                const geo = this.options.geos.find(item => item.id === this.geo_id)
                if (clearSelectedCountries){
                    this.countries = []
                }
                this.options.countries = Object.keys(geo.mapping)
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async send () {
            try {
                if (!await this.$refs.form.validate()) {
                    this.showParams = true
                } else {
                    const setTrim = data => {
                        Object.keys(data).map(key => {
                            if (data[key] && typeof data[key] === "string") data[key] = data[key].trim()
                        })

                        return data
                    }

                    const data = {
                        advrtsrIntegration: {
                            advertiser_id: this.popupData.adv ? this.popupData.adv.id : this.popupData.id,
                            traffic_model_id: this.traffic_model_id,
                            geo_id: this.geo_id,
                            name: this.name,
                            is_sync_available: this.is_sync_available,
                            login: this.login,
                            password: this.password,
                            endpoint: this.url,
                            description: this.description,
                            is_hot: this.is_hot,
                            countries: this.countries,
                            offers_accepted: this.offers_accepted,
                            offers_not_accepted: this.offers_not_accepted
                        }
                    }

                    data.advrtsrIntegration = setTrim(data.advrtsrIntegration)

                    // if (!this.is_falcon) {
                    const fields = Array.isArray(this.integrationParameters)
                        ? this.integrationParameters
                            .filter(item => item.send && item.get)
                            .map(item => {
                                const conditions = (item.conditions || [])
                                    .reduce((acc, { key, value }) => {
                                        if (key) {
                                            acc[key] = value
                                        }

                                        return acc
                                    }, {})

                                const isJoinable = Array.isArray(item.get) && item.separator

                                return {
                                    ...item,
                                    conditions,
                                    get: isJoinable ? item.get.join(item.separator) : item.get,
                                    separator: isJoinable ? item.separator : null
                                }
                            })
                        : null

                       data.advrtsrIntegration.custom_integration_params = JSON.stringify(this.params)
                       data.advrtsrIntegration.custom_integration_fields = fields && fields.length ? fields : null
                    // }

                    this.disabled = true
                    if (this.popupType === 'createIntegration') {
                        await send(this.$url.advrtsr_integration.create, 'POST', {data})

                        EventBus.$emit(`updateAdvertiserDetails-${data.advrtsrIntegration.advertiser_id}`)
                    }

                    if (this.popupType === 'editIntegration') {
                        data.advertiser_integration_id = this.popupData.id
                        data.advrtsrIntegration.id = this.popupData.id
                        data.id = this.popupData.id

                        await send(this.$url.advrtsr_integration.update, 'PUT', {data})

                        EventBus.$emit(`updateAdvertiserDetails-${data.advrtsrIntegration.advertiser_id}`)
                    }

                    EventBus.$emit('emitPopupEvent', {type: 'close'})
                }
            } catch (error) {
                if (error.response && error.response.data && error.response.data.result) {
                    let response = error.response.data.result.errors

                    if (response && (typeof response === "object" && !Array.isArray(response))) {
                        response = Object.keys(response).reduce((res, key) => {
                            const name = key.split('.')[1]
                            name ? res[name] = response[key] : res[key] = response[key]
                            return res
                        }, {})
                    }

                    this.$refs.form.setErrors(this.$errors(response))
                }
                this.disabled = false
                new ErrorHandler(error).send
            }
        },

        isJSON(data) {
            try {
                return JSON.parse(data)
            } catch (e) {
                return false
            }
        },

        initEditData () {
            const popupData = JSON.parse(JSON.stringify(this.popupData))
            this.name = popupData.name
            this.description = popupData.description
            this.url = popupData.endpoint
            this.login = popupData.login
            this.password = popupData.password
            this.is_hot = popupData.is_hot
            this.is_sync_available = popupData.is_sync_available
            this.traffic_model_id = popupData.traffic_model_id
            this.geo_id = popupData.geo_id
            this.countries = popupData.countries

            const fields = this.popupData.custom_integration_fields || '[]'
            if (fields && this.isJSON(fields)) {
                this.integrationParameters = JSON.parse(fields)

                this.integrationParameters.forEach(item => {
                    if (item.multiple) {
                        item.get = item.get.split(item.separator)
                    }

                    return item
                })

                if (!this.integrationParameters.length) {
                    this.integrationParameters = [{...this.templateParams}]
                }
            } else {
                this.integrationParameters = null
            }

            if (popupData.custom_integration_params) {
                let params = JSON.parse(popupData.custom_integration_params)

                if (params.offers && params.offers.length) {
                    params.offers = params.offers.map(element => {
                        if (typeof element.offer === 'number') {
                            element.offer = this.options.offers.find(offer => offer.id === element.offer).name
                        }
                        return element
                    })
                }

                this.params = params
            }

            this.offers_accepted = popupData.offers_accepted
            this.offers_not_accepted = popupData.offers_not_accepted
        }
    },

    async mounted () {
        try {
            this.disabled = true
            if (this.popupData.adv) {
                this.is_falcon = this.popupData.adv.is_falcon
                this.integration_type_id = this.popupData.adv.integration_type_id
            } else {
                this.is_falcon = this.popupData.is_falcon
                this.integration_type_id = this.popupData.integration_type_id
            }

            await this.getTypes()
            await this.getDataTeamIntegrations()

            this.createInterfaceFields()

            this.available_fields = this.popupData.available_fields

            if (this.popupType === 'editIntegration') {
                this.initEditData()
                this.setCountries()
            }

            if (this.integrationParameters) {
                this.integrationParameters = this.integrationParameters.map(item => {
                    if (!( 'type' in item )) {
                        this.$set(item, 'type', null)
                    }

                    const entries = Object.entries(item.conditions || {})
                    const conditions = entries.length
                        ? entries.map(([key, value]) => ({ key, value }))
                        : [{ key: '', value: '' }]

                    return {
                        ...item,
                        conditions
                    }
                });
            }

            this.disabled = false
            this.isMounted = true
            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch (e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
            new ErrorHandler(e).send
        }
    }
}
</script>

<style lang="scss">
.intEdit {
    .card {
        padding: 10px;
        background: #f8f8f8;
        margin-bottom: 10px;
        border-radius: 15px;

        .vs__dropdown-toggle {
            background: white;
        }
    }

    .vs__dropdown-option--selected {
        display: none !important;
    }

    .error {
        color: rgba(var(--vs-danger),1);

        .vs-input--placeholder {
            color: rgba(var(--vs-danger),1);
        }

        i {
            background-color: #fff;
        }

        input {
            border: 1px solid rgba(var(--vs-danger),1)!important
        }

        .vs__dropdown-toggle {
            border: 1px solid rgba(var(--vs-danger),1)!important;

            input {
                border-color: transparent !important;

                &::placeholder {
                    color: rgba(var(--vs-danger),1);
                }
            }
        }
    }

    .vs-con-input {
        input {
            box-shadow: none;
        }

        .vs-input--placeholder {
            transform: translate(0px) !important;
        }
    }
}
</style>
